import styled, { css } from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  label {
    font-style: normal;
    font-weight: normal;
    font-family: Inter, sans-serif;
    font-size: 0.9rem;
    color: var(--grey-100);
  }

  small {
    color: #ff6565;
    font-size: 13.5px;
    font-family: IBM Plex Sans;
    line-height: 12px;
    margin-top: 0.5rem;
  }
`;

interface StyledInputProps {
  error?: boolean;
}


export const StyledTextArea = styled.textarea<StyledInputProps>`
  width: 100%;
  height: 8rem;

  background-color: var(--black-100);

  margin-top: 12px;
  padding: 1rem;

  font-size: 0.9rem;

  border-radius: 5px;

  font-family: Inter, sans-serif;

  border: 1px solid transparent;

  ${props => props.error && css`
    border-color: var(--red);
  `}

  &:focus {
    outline: 0;
    border-color: var(--primary);
  }
`

export const RequiredHint = styled.span`
  font-weight: 600;
  color: var(--red);
  
  > span {
    color: var(--white);
  }
`;